jQuery(document).ready(function ($) {

    const links = document.querySelectorAll('.nav-bar__content .nvc__left li');
    const navLinks = [];
    const submenus = document.querySelectorAll('.submenus-container .submenu');
    const subCont = document.querySelector('.submenus-container');
    const nav = document.querySelector('nav');

    for (const link of links) {
        if(link.querySelector('.dropdown-reveal')) {
            navLinks.push(link);
        }
    }

    let navWhite;

    for(let j=0; j<links.length; j++) {
        for(let i = 0; i < navLinks.length; i++) {
            if(navLinks[i].querySelector('.dropdown-reveal')) {
                navLinks[i].addEventListener('mouseenter', () => {
                    for (let k=0; k<navLinks.length; k++) {
                        navLinks[k].querySelector('.dropdown-reveal').style.transform = '';
                        navLinks[k].querySelector('.dropdown-reveal').style.animation = '';
                    }

                    // nav.classList.add('nav-bar-white');
                    logo.attr('src',logo.attr('data-src-black'));
                    // console.log('_____ \n' + navWhite);
                    for (let submenu of submenus) {
                        submenu.style.display = 'none';
                    }
                    subCont.style.display = 'flex';
                    subCont.style.pointerEvents = 'auto';
                    subCont.style.opacity = '1';
                    submenus[i].style.display = 'flex';
                    submenus[i].style.opacity = '1';
                    // navLinks[i].querySelector('.dropdown-reveal').style.animation = 'arrowAnimation .4s';
                    // navLinks[i].querySelector('.dropdown-reveal').style.transform = 'rotateX(180deg) rotateY(180deg)';
                })
            }
            // else if(navLinks[i]) {
            //     navLinks[i].addEventListener('mouseenter', () => {
            //         for (let submenu of submenus) {
            //             submenu.style.display = 'none';
            //         }
            //         nav.classList.remove('nav-bar-white');
            //         subCont.style.opacity = '0';
            //         subCont.style.pointerEvents = 'none';
            //         logo.attr('src',logo.attr('data-src-white'));
            //     })
            // }
        }
        if(links[j]) {
            if(links[j].classList.contains('no-dropdown')) {
                links[j].addEventListener('mouseenter', () => {
                    for (let k=0; k<navLinks.length; k++) {
                        navLinks[k].querySelector('.dropdown-reveal').style.transform = '';
                        navLinks[k].querySelector('.dropdown-reveal').style.animation = '';
                    }
                    if(navWhite === false) {
                        // nav.classList.remove('nav-bar-white');
                        logo.attr('src',logo.attr('data-src-white'));
                    }
                    for (let submenu of submenus) {
                        submenu.style.display = 'none';
                    }
                    subCont.style.opacity = '0';
                    subCont.style.pointerEvents = 'none';
                    subCont.style.display = 'none';
                    // submenus[j].style.opacity = '0';
                })
            }
        }
    }

    nav.addEventListener('mouseleave', (e) => {
        if (e.target.closest('nav')) {
            for (let k=0; k<navLinks.length; k++) {
                navLinks[k].querySelector('.dropdown-reveal').style.transform = '';
                navLinks[k].querySelector('.dropdown-reveal').style.animation = '';
            }
            if(navWhite === false) {
                // nav.classList.remove('nav-bar-white');
                logo.attr('src',logo.attr('data-src-white'));
            }
            for (let submenu of submenus) {
                submenu.style.display = 'none';
            }
            subCont.style.opacity = '0';
            subCont.style.pointerEvents = 'none';
            subCont.style.display = 'none';
            submenus.forEach(el => el.style.opacity = '0');
        }
    })

    const navBar = document.querySelector('.nav-bar');
    const mainPageNavBar = document.querySelector('.default-page .nav-bar');
    const defPage = document.querySelector('.default-page');

    let scroll_start = 0;
    let startchange = $('.nav-bar-white-start');
    let offset = startchange.offset();
    let logo = $(".logo-desktop");
    let transparent = $('.nav-bar').data('transparent');

    $('.toggle-roadbar').on('click', function () {

        $('.toggle-roadbar__hamburger__container').toggleClass('open');

        if ($('.toggle-roadbar__hamburger__container').hasClass('open')) {

            $('.mobile-menu').addClass('mm-active');
            $('.nav-bar').css('top', '0 !important');

        } else {

            $('.mobile-menu').removeClass('mm-active');
            $('.dropdown-selector').removeClass('expand-dropdown');

        }

    });

    if(transparent == true){

        changeNavbar();

        if (startchange.length){
            $(document).scroll(function() {
                changeNavbar();
            });
        }

    }else{



        // $(".nav-bar").addClass('nav-bar-white');
        $(".hamburger-title").addClass('hamburger-title--dark');
        // $(".toggle-roadbar__hamburger").addClass('toggle-roadbar__hamburger--dark');
        logo.attr('src',logo.attr('data-src-black'));
    }

    function changeNavbar(){
        scroll_start = $(document).scrollTop();
        if (document.querySelector('.toggle-roadbar__hamburger__container').classList.contains('open')) {

        }else{
            if(scroll_start > $('.nav-bar-white-start').offset().top) {
                navWhite = true;
                // $(".nav-bar").addClass('nav-bar-white');
                $(".hamburger-title").addClass('hamburger-title--dark');
                // $(".toggle-roadbar__hamburger").addClass('toggle-roadbar__hamburger--dark');
                logo.attr('src',logo.attr('data-src-black'));
            } else {
                navWhite = false;
                $('.nav-bar').removeClass('nav-bar-white');
                $(".hamburger-title").removeClass('hamburger-title--dark');
                // $(".toggle-roadbar__hamburger").removeClass('toggle-roadbar__hamburger--dark');
                logo.attr('src',logo.attr('data-src-white'));
            }
        }
    }

    var lastScrollTop = 0;
    // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
    window.addEventListener("scroll", function () { // or window.addEventListener("scroll"....
        mainPageNavBar.style.marginTop = "0";
        var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        if (st > lastScrollTop) {
            // downscroll code
            if (!document.querySelector('.mobile-menu').classList.contains('mm-active')) {
                // mainPageNavBar.classList.remove('visible');
                navBar.classList.remove('visible');
                submenus.forEach(el => el.style.display = 'none');
                subCont.style.display = 'none';
            }

        } else {
            // upscroll code
            // mainPageNavBar.classList.add('visible');
            navBar.classList.add('visible');
            if(subCont.style.display === 'flex') {
                // navBar.classList.add('nav-bar-white');
                logo.attr('src',logo.attr('data-src-black'));
            }
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);

    let reveals = document.querySelectorAll('.mobile-menu li .dropdown-reveal');
    let revealsImgs = document.querySelectorAll('.mobile-menu li .dropdown-reveal img');
    let dropdowns = document.querySelectorAll('.mobile-menu li .dropdown-container');

    for (let i = 0; i<dropdowns.length; i++) {
        reveals[i].addEventListener('click', () => {
            for (let j = 0; j<dropdowns.length; j++) {
                if(i !== j) {
                    if(dropdowns[j].classList.contains('expand-dropdown')) {
                        dropdowns[j].classList.remove('expand-dropdown');
                        revealsImgs[j].style.animation = 'showHide .8s';
                        revealsImgs[j].style.transform = 'rotate(0)';
                    }
                }
            }

            dropdowns[i].classList.toggle('expand-dropdown');

            if(dropdowns[i].classList.contains('expand-dropdown')) {
                revealsImgs[i].style.animation = 'hideShow .8s';
                revealsImgs[i].style.transform = 'rotate(180deg)';
            } else {
                revealsImgs[i].style.animation = 'showHide .8s';
                revealsImgs[i].style.transform = 'rotate(0)';
            }
        });
    }

    document.querySelector('.toggle-roadbar').addEventListener('click', () => {
        for (let i = 0; i<dropdowns.length; i++) {
            if(!document.querySelector('.mobile-menu').classList.contains('.mm-active')) {
                revealsImgs[i].style.transform = 'rotate(0)';
            }
        }
    })

    window.addEventListener('scroll', () => {
        if ((document.documentElement.scrollHeight - document.documentElement.clientHeight) <= -1 * defPage.getBoundingClientRect().top + 200) {
            navBar.classList.remove('visible');
        }
    })

    let page = document.querySelector('#our-projects-page, #case-study, #contact-page, #career-page');


    if(page !== null && page.classList.contains('default-page')) {
        // navBar.classList.add('nav-bar-white');
        logo.attr('src',logo.attr('data-src-black'));
    }
    // });

    // expand mobile menu elements when arrow is clicked



});